@if (consentType === 'econsent' || consentType === 'tcpa') {
<dx-consent
  [enabled]="field?.enabled"
  [consent]="consent"
  [required]="consentType === 'tcpa' ? field.required : consent.required"
  [isSubmitted]="isPageSubmitted"
  #pFieldValue="ngModel"
  [(ngModel)]="field.data.value"
  [consents]="consentLibrary"
  (selectionChange)="captureContent(consent)"
  [fieldId]="'primary-' + consentType"
  [consentField]="field"
  [name]="'econsent-' + consentType"
></dx-consent>
} @if (consentType === 'additionaleconsent') { @for (consent of additionalConsents; track consent.acknowledgeId; let i = $index) {
<dx-consent
  [enabled]="field?.enabled"
  [consent]="consent"
  [isSubmitted]="isPageSubmitted"
  [required]="consent.required"
  [consentField]="field"
  [name]="'additional-econsent-' + i"
  [consents]="consentLibrary"
  (selectionChange)="captureContent(consent)"
  [(ngModel)]="consent.isAccepted"
  [fieldId]="consent.acknowledgeId + '-' + i"
></dx-consent>
} }
